export default function replaceLinks(text) {
  console.log("replace links", text);
  if (!text) {
    return text;
  }

  // 1. Custom link format: {textToDisplay.(actualLink)}
  const linkRegex = /{([^}]+)\.\(([^)]+)\)}/g;
  text = text.replace(
    linkRegex,
    (match, textToDisplay, actualLink) => {
      return `<a href="${actualLink}">${textToDisplay}</a>`;
    }
  );

  // 2. Plain URLs: protect existing <a> tags, then convert remaining plain URLs
  const placeholders = [];
  text = text.replace(/<a\b[^>]*>.*?<\/a>/gi, (match) => {
    placeholders.push(match);
    return `__LINK_PLACEHOLDER_${placeholders.length - 1}__`;
  });

  const urlRegex = /(https?:\/\/[^\s<)"']+|(?:www\.)[^\s<)"']+)/g;
  text = text.replace(urlRegex, (url) => {
    const href = url.startsWith("http") ? url : `https://${url}`;
    return `<a href="${href}">${url}</a>`;
  });

  placeholders.forEach((original, i) => {
    text = text.replace(`__LINK_PLACEHOLDER_${i}__`, original);
  });

  return text;
}
